//dependencies
import { useAutoAnimate } from "@formkit/auto-animate/react";
import React, { useState } from "react";

import { faPencil } from "@fortawesome/pro-solid-svg-icons";

//components
import Icon from "../../../../../../components/Icon/Icon";
import TruncatedText from "../../../../../../components/Text/TruncatedText";
import { MeasureCanvas } from "../../../../../../components/Text/TruncatedText/internal/MeasureCanvas";
import { buildFontTemplate } from "../../../../../../components/Text/TruncatedText/internal/TruncatedTextUtils";

//store
import { useEditFormStore } from "../../useEditFormStore";

interface TitleInputProps {
	defaultTitle: string;
}

const TitleInput = (props: TitleInputProps) => {
	const { defaultTitle } = props;

	const { name, setName, invalidNameMessage, validateName } = useEditFormStore((state) => ({
		name: state?.name,
		setName: state.setName,
		invalidNameMessage: state.invalidNameMessage,
		validateName: state.validateName,
	}));
	const [isEditingName, setIsEditingName] = useState(false);
	const [ref] = useAutoAnimate();
	const fontString = buildFontTemplate("sub-heading", "semi-bold");
	const editWidth = new MeasureCanvas().getTextWidth(name, fontString);

	return (
		<div>
			{isEditingName ? (
				<form
					ref={ref}
					onSubmit={(e) => {
						e.preventDefault();
						if (validateName(defaultTitle)) {
							setIsEditingName(false);
						}
					}}
					onBlur={() => {
						if (validateName(defaultTitle)) {
							setIsEditingName(false);
						}
					}}
				>
					<div className="group flex w-full items-center gap-[8px] text-neutral-9">
						<input
							autoFocus
							className="w-max-full border-0 border-b-[0.5px] border-neutral-9 p-0 text-sub-heading font-semi-bold text-neutral-9 outline-none hover:cursor-text focus:border-primary-4 active:border-primary-4 disabled:border-0 disabled:border-b-[0.5px] disabled:bg-transparent disabled:text-neutral-9"
							style={{
								width: editWidth, // Dynamic width calculation
								minWidth: "200px",
								maxWidth: "800px",
							}}
							value={name}
							onChange={(e) => setName(e.target.value)}
							data-testid="edit-form-title-input"
						/>
						<button className="border-0 bg-transparent p-0" type="submit" aria-label="Save form title">
							<Icon
								className="text-neutral-5 hover:cursor-pointer hover:text-neutral-7"
								size="small"
								icon={faPencil}
							/>
						</button>
					</div>
					{invalidNameMessage && <div className="text-caption text-red-6">{invalidNameMessage}</div>}
				</form>
			) : (
				<h2
					className="group flex items-center gap-[8px] text-neutral-9"
					onClick={() => {
						setIsEditingName(true);
						setName(name);
					}}
				>
					<span className="w-max-full min-h-[32px] overflow-hidden whitespace-nowrap border-solid border-neutral-9 text-sub-heading font-semi-bold text-neutral-9 hover:cursor-text group-hover:border-b-[0.5px]">
						<TruncatedText
							testID="form-name"
							maxWidth={780}
							weight="semi-bold"
							size="sub-heading"
							text={name}
						/>
					</span>
					<button
						className="border-0 bg-transparent p-0"
						onClick={() => {
							setIsEditingName(true);
							setName(name);
						}}
						aria-label="Edit form title"
					>
						<Icon
							className="text-neutral-5 hover:cursor-pointer hover:text-neutral-7"
							size="small"
							icon={faPencil}
						/>
					</button>
				</h2>
			)}
		</div>
	);
};

export default TitleInput;
